export const locale = {
    lang: 'nl',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'INSTELLINGEN',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Upload medewerkers database',
            'BOTON': 'Set'
          },
          'BOT2':{
            'TITULO': 'Upload bedrijfslogo',
            'BOTON': 'Set'
          },
          'BOT3':{
            'TITULO': 'Technical requirements information',
            'BOTON': 'Zie meer'
          }
        },
        'BD':{
          'TITUHEAD':' Upload de database van medewerkers',
          'INFO': 'Upload uw bedrijfsmedewerkersdatabase in het systeem',
          'BOTONES':{
            'DescTemp': 'Download sjabloon'
          },
          'MENSAJES':{
            'CARGABD': 'Upload BD',
            'STATUS': 'STATUS',
            'CORRECTO': 'De database is met succes geüpload',
            'ERROR': 'Een fout in het uploadproces'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Upload bedrijfslogo',
          'INFO': 'Upload uw bedrijfslogo afbeelding',
          'MENSAJES':{
            'CARGABD': 'Upload logo-afbeelding',
            'STATUS': 'STATUS',
            'CORRECTO': 'Het logo is met succes geüpload',
            'ERROR': 'Een fout in het uploadproces'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Informatie over technische vereisten',
          'INFO': 'Eisen aan het platform om een optimale functionaliteit te garanderen',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'STATUS',
            'CORRECTO': 'Met succes geüpload',
            'ERROR': 'Een fout in het uploadproces'
          }
        }
      }
    }
};
